angular.module('unica_invitation_room.invitation_room_services')

.factory('InvitationRoomDeleteService', function ($http, getBaseApiURL) {

	var invitationRoomDeleteService = {};

	invitationRoomDeleteService.delete = function (invitationRoomId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-room/delete/' + invitationRoomId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	invitationRoomDeleteService.erase = function (eventId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-room/delete-all/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return invitationRoomDeleteService;
});